import { accommodationRangeIdZodSchema } from "@@/shared/acquire/accommodation-range-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const availabilityDeleteCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("AVAILABILITY_DELETE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    rangeId: accommodationRangeIdZodSchema,
    productId: productIdZodSchema,
    providerId: providerIdZodSchema,
});

type AvailabilityDeleteCommand = z.infer<
    typeof availabilityDeleteCommandZodObject
>;

const availabilityDeleteCommandFactoryParamsZodObject =
    availabilityDeleteCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<
    typeof availabilityDeleteCommandFactoryParamsZodObject
>;

const availabilityDeleteCommandFactory = (params: FactoryParams) => {
    const availabilityEditCommand: AvailabilityDeleteCommand = {
        ...params,
        _id: generateId({ prefix: "availability_delete_command__" }),
        _type: "AVAILABILITY_DELETE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return availabilityEditCommand;
};

export {
    availabilityDeleteCommandFactory,
    availabilityDeleteCommandFactoryParamsZodObject,
    availabilityDeleteCommandZodObject,
};
export type {
    AvailabilityDeleteCommand,
    FactoryParams as availabilityDeleteCommandFactoryParams,
};
